import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  courses:[],
  courseDetails: {},
  loading: false,
  error: null,
  totalPage:1
};

const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    getCourses(state) {
      state.loading = true;
    },
    getCoursesSuccess(state, action) {
      state.loading = false;
      state.courses = action.payload.currentPage!=1? [...state.courses, ...action.payload.data]:action.payload.data // Merge previous courses with new data
      state.error = null;
      state.totalPage = action.payload.totalPages;
    },
    getCoursesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getSingleCourses(state) {
      state.loading = true;
    },
    getSingleCoursesSuccess(state, action) {
      state.loading = false;
      state.courseDetails = action.payload;
      state.error = null;
    },
    getSingleCoursesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getCourses,
  getCoursesSuccess,
  getCoursesFailure,
  getSingleCourses,
  getSingleCoursesSuccess,
  getSingleCoursesFailure,
} = courseSlice.actions;

export default courseSlice.reducer;
